import { FC } from "react";
import { PhoneXMarkIcon } from "@heroicons/react/24/outline";

import {
  AccountHistoryCard,
  AccountHistoryCardBasePropsI,
} from "shared/ui/activity-log/cards-v2/base";
import { HistoryCardActivityType } from "shared/ui/activity-log/cards-v2/base/activity-type";
import { HistoryCardContactInfo } from "./base/contact-info";

const ACTIVITY_TYPE_CONFIG = {
  icon: PhoneXMarkIcon,
  title: "Suppressed by the customer",
};

const HistoryCardSuppression: FC<AccountHistoryCardBasePropsI> = ({
  activity,
}) => (
  <AccountHistoryCard createdAt={activity.created_at}>
    <div className="flex flex-col gap-4">
      <HistoryCardActivityType config={ACTIVITY_TYPE_CONFIG} />

      {activity.contact && (
        <HistoryCardContactInfo
          contact={activity.contact}
          className="[&_a]:pointer-events-none [&_a]:line-through [&_h5]:line-through"
        />
      )}
    </div>
  </AccountHistoryCard>
);

export default HistoryCardSuppression;
